import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import 'core-js/features/array/find'
import 'core-js/features/array/includes'
import 'core-js/features/number/is-nan'
import './index.css'
import './i18n'

import App from './App'
import React from 'react'
import ReactDOM from 'react-dom'

ReactDOM.render(<App />, document.getElementById('root'))